import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const Img = ({ src, ...props }) => {
  const { data } = useQuery({
    queryKey: ['img', src],
    queryFn: () => axios.get(src, { responseType: 'blob' }),
    select: (data1) => data1.data
  });

  return <img {...props} alt='' src={data ? URL.createObjectURL(data) : data} />;
};
